import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userInfoWrapper: {
    display: 'flex',
    gap: 8,
    marginBottom: 8,
    backgroundColor: theme.palette.background.paper,
    padding: 8,
    borderRadius: '0 0 4px 4px',
    maxHeight: '170px',
    overflow: 'hidden',
  },
  avatar: {
    width: '150px',
  },
  userDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  info: {
    flex: 1,
  },
  infoName: {
    fontWeight: 600,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: 8,
  },
  userDetailsWrapper: {},
  userRelationsWrapper: {
    width: '100% !important',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  userRelationsContainer: {
    backgroundColor: theme.palette.background.paper,
    padding: 8,
    borderRadius: 4,
  },
  userRelationsHeader: {
    display: 'flex',
    gap: 8,
    color: theme.palette.text.primary,
    textDecoration: 'unset',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  userRelationsTitle: {
    fontWeight: 600,
    margin: '8px 0 8px 8px',
    fontSize: 14,
  },
  userRelationsCounter: {
    fontWeight: 600,
    margin: '8px 0',
    fontSize: 14,
    color: theme.palette.grey[600],
  },
}));
